import './Favorites.scss';
import React, {useContext} from "react";
import {GlobalContext} from "../../context";

export function ResultHeaderFavorites({selectMenu, setSelectMenu}) {
    const {productsArray, wishlistArray} = useContext(GlobalContext);

    return (
        <div className={`rh-favorites mb-1 ${selectMenu}`}>
            <div
                className={`rhf-entry rhf-results btn ${selectMenu === 'results' ? 'selected' : ''}`}
                onClick={
                    () => setSelectMenu(
                        'results')
                }
            >
                {productsArray?.length ?? '0'} Ergebnisse
            </div>
            {/*<div*/}
            {/*    className={`rhf-entry rhf-wishlist btn ${selectMenu === 'wishlist' ? 'selected' : ''}`}*/}
            {/*    onClick={*/}
            {/*        () => setSelectMenu('wishlist')*/}
            {/*    }*/}
            {/*>*/}
            {/*    {wishlistArray?.length ?? '0'} Favoriten*/}
            {/*</div>*/}
        </div>
    );
}